import { ActionTypes } from '../actions';

const initialState = {
  races: {},
  approved_races: [],
  unapproved_races: [],
  selectedRace: undefined,
};

const RaceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_RACES:
      return {
        ...state,
        races: action.payload.reduce((acc, curr) => ({
          ...acc,
          [curr._id]: curr,
        }), {}),
      };

    case ActionTypes.SET_ALL_APPROVED_RACES:
      return {
        ...state,
        approved_races: action.payload,
      };

    case ActionTypes.SET_ALL_UNAPPROVED_RACES:
      return {
        ...state,
        unapproved_races: action.payload,
      };

    case ActionTypes.SET_SELECTED_RACE:
      return {
        ...state,
        selectedRace: state.races[action.payload],
      };

    case ActionTypes.SET_SELECTED_RACE_OBJ:
      return {
        ...state,
        selectedRace: action.payload,
      };

    case ActionTypes.CLEAR_RACES:
      return { ...state, races: initialState.races, selectedRace: undefined };

    case ActionTypes.CLEAR_SELECTED_RACE:
      return { ...state, selectedRace: initialState.selectedRace };

    case ActionTypes.SET_ELECTIONS:
      return initialState;

    default:
      return state;
  }
};

export default RaceReducer;
